module.exports = __webpack_public_path__ + "img/skipping.f9d91bd1.svg";